<template>
<el-container>
  <el-main>
      <div class="forget-main">
        <div style="width: 400px; margin: 0 auto;" :style="{ 'padding-top': `${mainTop}px` }">
          <img src="/static/img/brandmark-design.svg" style="width: 100%;">
        </div>
        <div class="forget-info">
          <div v-show="sendEmailSuccess" style="padding:6%;">
            <div style="margin: 15px 0px;">
              <div class="main-color" style="text-align: center;line-height: 30px; width: 100%;min-height: 20px;height: 170px;display: flex;align-items: center; justify-content: center;">
                <div style="min-height: 30px;">The password reset email has been sent to '{{inputEmail}}'.</div>
              </div>
              <div style="margin-top:20px;width: 100%;">
                <div style="width: 140px; margin: 0 auto;">
                  <el-button class="forget_send" @click="submitBack()" data-index="forget-button">Back</el-button>
                </div>
              </div>
            </div>
          </div>
          <div style="padding:6%;" v-show="!sendEmailSuccess">
            <form class="el-form demo-ruleForm forget-form" v-show="!sendEmailSuccess">
              <div style="margin-top:10px;">
                <div class="forget-name">{{$t('electronEmail')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input" style="height: 80px;">
                    <input type="text" autocomplete="off" class="el-input__inner" ref="email" placeholder="Email">
                    <span class="email-error" v-show="emailError">The email address is incorrect.</span>
                  </div>
                </div>
              </div>
              <div class="marginTop40" style="height: 70px;"></div>
              <div class="marginTop40" style="width: 100%;">
                <div style="width: 140px; margin: 0 auto;">
                  <el-button class="forget_send" @click="submitForm()" data-index="forget-button">Reset Password</el-button>
                </div>
                <div style="text-align: center;margin-top: 10px;">
                  <router-link :to="{ name: 'login'}" class="forgotpassword">Back to sign in</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { forgetPass } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'

export default {
  name: 'forget',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      emailError: false,
      inputEmail: '',
      verifyFail: false,
      language: this.common.languageSet(this),
      sendEmailSuccess: false,
      mainTop: document.documentElement.clientHeight * 0.11
    }
  },
  mounted: function () {
    // 判断是否登陆
    var token = localStorage.getItem('token')
    if (token !== null) {
      this.$router.push({name: 'login'})
    }
  },
  methods: {
    submitForm () {
      var that = this
      var email = this.$refs['email'].value
      if (email === '' || email === null) {
        this.emailError = true
      } else {
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,})$/
        if (!pattern.test(email)) {
          this.emailError = true
        } else {
          this.emailError = false
        }
      }
      if (this.emailError === false) {
        this.inputEmail = email
        var sessionid = this.common.sessionidGet(this)
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {
          'email': email,
          'time': time,
          'sessionid': sessionid,
          'language': this.language,
          'operation': 'forgetPass'
        }
        var data = this.common.encryptionData(dataJson, this)
        forgetPass(data).then(res => {
          if (res.flag === '200') {
            sessionStorage.setItem('emailSendTips', that.inputEmail)
            sessionStorage.removeItem('verifyEmailSendEmail')
            this.sendEmailSuccess = true
          } else {
            this.emailError = true
          }
        })
      }
    },
    submitBack () {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped>
.el-main{background-color: rgba(83, 102, 163, 0.2);}
/deep/ .top-pc{margin-top: 60px;}
.forget-main{background-color: rgba(83, 102, 163, 0.2);width:100%;height:560px; margin:0 auto;height: 100vh;}
.forget-info{margin: -100px auto 0 auto; width: 520px;min-height: 305px;background-color: rgba(255, 255, 255, 0.6);border: none;border-radius: 5px;}
.forgettext{font-weight: 650;font-size: 24px; height: 60px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;}
.forget-form{margin:15px 0px; color:#606266;font-size: 14px;}
.forget-form input{ margin-top:10px;}
.forget_send, .forget_send:active{ width: 140px;height: 40px;font-size:14px; background-color:rgba(83, 102, 163, 1);border-radius: 5px;color: #FFFFFF;margin-top:20px; border: 1px solid rgba(83, 102, 163, 1);}
.forget_send:hover{background-color: #FFF; color: rgba(83, 102, 163, 1);}
.forget-other{ text-align:center;}
.forget-other a{ font-size:14px; color:#5392F9;text-decoration-line: none;}
.el-input.is-active .el-input__inner, .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
/deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
/deep/ .el-button:focus, .el-button:hover{width: 140px;height: 40px; font-size:14px;background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
.email-error{color: #FF001F; font-size: 10px;display: block; margin-top: -8px;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.forgotpassword{color: rgba(83, 102, 163, 1);text-decoration: none; }
.forgotpassword:hover{color: #296FF7;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.line {width: 100%;height: 44px;line-height: 44px;font-size: 14px;text-align: center;background-image:url(/static/img/login/line.svg);background-repeat:repeat-x;background-position: center;}
@media only screen and (min-width:431px) and (max-width:600px) {
  .forget-info{width: 420px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
@media only screen and (min-width:391px) and (max-width:430px) {
  .forget-info{width: 380px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
@media only screen and (max-width:390px) {
  .forget-info{width: 350px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/forgetPass.vue